import React, { FC, useLayoutEffect, useRef } from 'react';
import s from './ErrorModal.scss';
import { useTranslation } from '@wix/wix-i18n-config';
import { Dismiss } from '@wix/wix-ui-icons-common';

interface ErrorModalProps {}

export const ErrorModal: FC<ErrorModalProps> = ({}) => {
  const { t } = useTranslation();

  const dialogRef = useRef<HTMLDialogElement>(null);

  useLayoutEffect(() => {
    const dialog = dialogRef.current;

    const handleOutsideClick: EventListener = (e) => {
      if (dialog !== e.target) {
        return;
      }
      dialog?.close();
    };

    if (dialog) {
      dialog.addEventListener('click', handleOutsideClick);

      return () => {
        dialog.removeEventListener('click', handleOutsideClick);
      };
    }
  }, []);

  useLayoutEffect(() => {
    dialogRef.current?.showModal();
  }, []);

  const onButtonXClick = () => {
    dialogRef.current?.close();
  };

  const onRefreshButtonClick = () => {
    window.location.reload();
  };

  return (
    <dialog ref={dialogRef} className={s.modal}>
      <div className={s.container}>
        <div className={s.title}>
          {t('app.templates.grid.errorModal.title')}
        </div>
        <div className={s.subtitle}>
          {t('app.templates.grid.errorModal.subtitle')}
        </div>
        <button className={s.refreshButton} onClick={onRefreshButtonClick}>
          {t('app.templates.grid.errorModal.refreshButton')}
        </button>
        <button
          className={s.closeButton}
          aria-label="Close"
          onClick={onButtonXClick}
        >
          <Dismiss className={s.closeIcon} />
        </button>
      </div>
    </dialog>
  );
};
